import React, { useEffect, ReactNode } from 'react';
import { useSnackbar } from 'notistack';
import Api from 'utils/api';

const ErrorWatcher = () => {
    const {enqueueSnackbar} = useSnackbar();

    const numErr = async (error: any) => {
        let message: ReactNode = null;

        let data = error.response.data;
        if (data instanceof Blob && data.type === 'application/json')
            data = JSON.parse(await data.text());

        if (data.message) {
            message = data.message;
        } else if (data.errors) {
            message = Object.entries<string[]>(data.errors).map(e => <div key={e[0]}>{e[0]} {e[1].join(', ')}</div>)
        }

        enqueueSnackbar(message, {
            variant: 'error',
            style: {whiteSpace: 'pre-line'},
        });
    };

    const networkErr = () => {
        enqueueSnackbar('NETWORK ERROR', {
            variant: 'error',
        });
    };

    useEffect(() => {
        Api.subscribe('onError400', numErr);
        Api.subscribe('onError403', numErr);
        Api.subscribe('onError409', numErr);
        Api.subscribe('onError422', numErr);
        Api.subscribe('onError500', numErr);
        Api.subscribe('onError503', numErr);
        Api.subscribe('onErrorNetwork', networkErr);
        // eslint-disable-next-line
    }, []);

    return null;
};

export default ErrorWatcher;
